<template>
  <QS-scroller-box>
    <EchoLastData :dataList="orderPayPreview" :model="topPreviewModel" />
    <QS-h4-title title="交接信息" />
    <el-form ref="stockRef" :model="stock" :rules="rulesStock">
      <column-box :labelWidth="160" :column="2">
        <el-form-item
          prop="actualTakeOverName"
          :label="'提车人姓名' + columnSeparator"
        >
          <el-input
            v-model="stock.actualTakeOverName"
            clearable
            maxlength="20"
            placeholder="请输入提车人姓名"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          prop="actualTakeOverTel"
          :label="'提车人联系电话' + columnSeparator"
        >
          <el-input
            v-model="stock.actualTakeOverTel"
            class="lengthen"
            clearable
            v-number:phone
            placeholder="请输入提车人联系电话"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          prop="takeOverManager"
          :label="'交接车管' + columnSeparator"
        >
          <el-select
            v-model="stock.takeOverManager"
            placeholder="请选择交接车管"
            clearable
            filterable
          >
            <el-option
              v-for="item in carTubeList"
              :label="item.userName"
              :value="item.id"
              :key="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="displayMile" :label="'表显里程' + columnSeparator">
          <el-input
            v-model="stock.displayMile"
            v-number:km
            class="lengthen"
            placeholder="请输入表显里程"
            clearable
          >
            <template slot="append"
              >公里</template
            >
          </el-input>
        </el-form-item>
        <el-form-item
          prop="remainingReserves"
          :label="'剩余电量/油量' + columnSeparator"
        >
          <el-input v-model="stock.remainingReserves" clearable maxlength="20">
          </el-input>
        </el-form-item>
        <el-form-item
          prop="takeOverTime"
          :label="'交接完成时间' + columnSeparator"
        >
          <el-date-picker
            v-model="stock.takeOverTime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="请选择交接完成时间"
            class="lengthen"
            clearable
            :picker-options="takeOverTimeOption"
          />
          <p class="form-item-tips-red">
            交接完成时间将影响后续退车核算相关费用，请务必准确填写
          </p>
        </el-form-item>
        <el-form-item prop="hasKey" :label="'车钥匙' + columnSeparator">
          <el-radio-group v-model="stock.hasKey">
            <el-radio :label="1">有钥匙</el-radio>
            <el-radio :label="0">无钥匙</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          prop="hasCarLicense"
          :label="'行驶证' + columnSeparator"
        >
          <el-radio-group v-model="stock.hasCarLicense">
            <el-radio :label="1">有行驶证</el-radio>
            <el-radio :label="0">无行驶证</el-radio>
          </el-radio-group>
          <p class="form-item-tips">
            与车辆标签「无行驶证」关联，选择无行驶证，会自动勾选「无行驶证」标签
          </p>
        </el-form-item>
        <el-form-item :label="'备注' + columnSeparator">
          <el-input
            v-model="stock.remarks"
            type="textarea"
            placeholder="请输入备注"
            maxlength="500"
            show-word-limit
            clearable
          >
          </el-input>
        </el-form-item>
      </column-box>
    </el-form>
    <QS-h4-title title="验车信息" />
    <div class="fileUpload">
      <div class="txt">{{ `验车交接文件${columnSeparator}` }}</div>
      <div>
        <div
          class="imgList"
          v-for="(item, index) in checkCarImgData"
          :key="index"
        >
          <div class="imgList_item">
            <UploadCommon
              :fileList="item.urlList"
              :limit="10"
              :sizeType="4"
              :multiple="true"
              fileTitle="最多可上传10张图片（支持批量添加）"
              fileTitleWidth="240px"
              :isAlone="false"
              @uploadSuccess="checkCarImgDataChange"
              @deleteUploadHandle="checkCarImgDataChange"
              commonUpload
              group="vehicle"
              code="vehicle_inspection_file"
            />
          </div>
          <div class="imgList_summay">
            <span>说明:</span>
            <el-input
              style="width:200px;margin-bottom:10px;margin-left:10px"
              v-model="item.remark"
              :disabled="item.urlList.length === 0"
              maxlength="200"
              type="textarea"
              placeholder="请输入内容"
              show-word-limit
              clearable
            />
          </div>
        </div>
      </div>
    </div>
    <div class="photoUpload">
      <div class="txt">{{ `车辆相关照片${columnSeparator}` }}</div>
      <div>
        <div
          class="imgList"
          v-for="(item, index) in aboutCarImgsData"
          :key="index"
        >
          <div>
            <UploadCommon
              :fileList="item.urlList"
              :limit="10"
              :sizeType="4"
              :multiple="true"
              fileTitle="最多可上传10张图片（支持批量添加）"
              fileTitleWidth="240px"
              :isAlone="false"
              @uploadSuccess="isAddImgsItem"
              @deleteUploadHandle="isAddImgsItem"
              commonUpload
              group="order"
              code="order_vehicle_pic"
            />
          </div>
          <div class="imgList_summay">
            <span>说明:</span>
            <el-input
              style="width:200px;margin-bottom:10px;margin-left:10px"
              v-model="item.remark"
              :disabled="item.urlList.length === 0"
              maxlength="200"
              type="textarea"
              placeholder="请输入内容"
              show-word-limit
              clearable
            />
          </div>
        </div>
      </div>
    </div>
    <QS-h4-title title="验车视频" />
    <div class="upload-box">
      <p class="upload-box__title">
        验车视频
        <span class="sub-title-line">（可批量上传最多5个，每个不超过100MB，支持mp4/mov/3gp等视频格式）</span>
      </p>
      <div class="upload-box__content">
        <UploadCommon
          :fileList="inspectionVideoPlus"
          :limit="5"
          :multiple="true"
          :sizeType="4"
          fileTitle="最多上传5个"
          fileTitleWidth="240px"
          :isAlone="false"
          listType="text"
          acceptType=".mp4,.mov,.3gp,.avi,.wmv,.flv,.mkv,.webm"
          commonUpload
          group="vehicle"
          code="vehicle_inspection_file"
        />
      </div>
    </div>
    <template slot="bottomAction">
      <el-button @click="cancel" size="mini">取消</el-button>
      <el-button @click="confirm" :loading="loading" size="mini" type="primary">确认，下一步</el-button>
    </template>
  </QS-scroller-box>
</template>
<script>
// api
import { editOutIn, getOutInDetails, getTempOutInDetails, stockLogFindLastOne } from '@/api/domain/cars'
import { getAllEmployeeList } from '@/api/carManage/index.js'
import { leaseContractOrderDetail } from '@/api/domain/orders'
// 其他
import { formatDate } from '@/utils'
import { validateMobile } from '@/utils/validate'
import moment from 'moment'
import EchoLastData from '../../../components/EchoLastData.vue'
import { orderPayPreview } from '../../config/echoLastData'

export default {
  components: {
    EchoLastData,
  },
  props: {
    active: {
      type: Number,
      default: -1,
    },
    topPreviewModel: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      orderPayPreview,
      stock: {
        displayMile: '',
        takeOverManager: '',
        takeOverTime: '',
        remarks: '',
        actualTakeOverName: '',
        actualTakeOverTel: '',
        remainingReserves: '',
        hasKey: '',
        hasCarLicense: '',
      },
      loading: false,
      carTubeList: [], // 车管
      // 验车交接文件:
      checkCarImgData: [
        {
          remark: '',
          urlList: [],
        },
      ],
      // 车辆相关照片
      aboutCarImgsData: [
        {
          remark: '',
          urlList: [],
        },
      ],
      // 验车视频
      inspectionVideoPlus: [],
      // 出入库校验
      rulesStock: {
        hasKey: [
          {
            required: true,
            message: '不能为空',
            trigger: ['blur', 'change'],
          },
        ],
        hasCarLicense: [
          {
            required: true,
            message: '不能为空',
            trigger: ['blur', 'change'],
          },
        ],
        displayMile: [
          {
            required: true,
            message: '不能为空',
            trigger: 'blur',
          },
          {
            required: true,
            message: '不能为空',
            trigger: 'blur',
          },
        ],
        takeOverManager: [
          {
            required: true,
            message: '不能为空',
            trigger: ['blur', 'change'],
          },
        ],
        takeOverTime: [
          {
            required: true,
            message: '不能为空',
            trigger: 'blur',
          },
        ],
        remarks: [
          {
            required: true,
            message: '不能为空',
            trigger: 'blur',
          },
        ],
        actualTakeOverName: [
          {
            required: true,
            message: '不能为空',
            trigger: 'blur',
          },
        ],
        actualTakeOverTel: [
          {
            required: true,
            trigger: 'blur',
            validator: validateMobile,
          },
          {
            min: 11,
            max: 11,
            message: '格式不正确',
            trigger: 'blur',
          },
        ],
        remainingReserves: [
          {
            required: true,
            message: '不能为空',
            trigger: 'blur',
          },
        ],
      },
      signDate: '', // 交接完成时间选择范围开始时间依赖：签约时间
    }
  },
  created() {
    // eslint-disable-next-line vue/no-mutating-props
    this.topPreviewModel.orderId = this.$route.query.orderId || ''
  },
  mounted() {
    this.init()
  },
  methods: {
    // 从URL的key参数中提取文件名
    extractFileName(url) {
      if (!url) return ''
      try {
        const queryString = url.split('?')[1] || ''
        const params = new URLSearchParams(queryString)
        const key = params.get('key') || ''
        if (key) {
          return decodeURIComponent(key.split('/').pop() || '')
        }
        return decodeURIComponent(url.split('?')[0].split('/').pop() || '')
      } catch (e) {
        return ''
      }
    },
    // 格式转换文件
    transferCarImgDataChange(allCarImg, num) {
      // 删除中间 剩下有图片的
      const outputArr = allCarImg.filter((item) => {
        return item.urlList.length !== 0
      })

      // 补充 最后一张
      if (outputArr.length < num) {
        outputArr.push({
          remark: '',
          urlList: [],
        })
      }
      return outputArr
    },
    // 车辆相关照片
    isAddImgsItem() {
      this.aboutCarImgsData = this.transferCarImgDataChange(this.aboutCarImgsData, 20)
    },
    // 验车交接文件
    checkCarImgDataChange() {
      this.checkCarImgData = this.transferCarImgDataChange(this.checkCarImgData, 5)
    },
    //  获取车管
    async getCarTubeList() {
      const { code, data } = await getAllEmployeeList()
      if (code === 1) {
        this.carTubeList = data
      }
    },
    // 获取详情
    getLeaseContractOrderDetail() {
      leaseContractOrderDetail({
        orderId: this.topPreviewModel.orderId,
      }).then((res) => {
        const { data } = res
        if (data) {
          const {
            carId,
            customerName,
            planName,
            modelName,
            plateNo,
            deptName,
            rentCategoryName,
            startDate,
            endDate,
            entRentOrderId,
            brandName,
            seriesName,
          } = data

          /* eslint-disable vue/no-mutating-props */
          this.topPreviewModel.deptName = deptName
          this.topPreviewModel.customerName = customerName
          this.topPreviewModel.planName = planName || '自定义'
          this.topPreviewModel.brandName = brandName
          this.topPreviewModel.seriesName = seriesName
          this.topPreviewModel.modelName = modelName
          this.topPreviewModel.plateNo = plateNo
          this.topPreviewModel.carId = carId
          if (startDate && endDate) {
            this.topPreviewModel.startStopDate = `${startDate}至${endDate}`
          }
          this.topPreviewModel.entRentOrderId = entRentOrderId
          this.topPreviewModel.categoryName = rentCategoryName
          /* eslint-enable vue/no-mutating-props */

          //  获取出入库id
          this.getStockLogFindLastOne().then((id) => {
            this.getOutInDetails(id)
          })
        }
      })
    },
    // 回显
    async getOutInDetails(id) {
      const allData = await Promise.allSettled([
        getTempOutInDetails({ id }),
        getOutInDetails({ id }),
      ])
      const tempOutInDetails = allData[0]?.value?.data || {}
      const outInDetails = allData[1]?.value?.data || {}
      this.stock.actualTakeOverName =
        outInDetails.stockInfoVo.actualTakeOverName ||
        tempOutInDetails.actualTakeOverName
      this.stock.actualTakeOverTel =
        outInDetails.stockInfoVo.actualTakeOverTel ||
        tempOutInDetails.actualTakeOverTel
      this.stock.takeOverTime =
        outInDetails.stockInfoVo.takeOverTime ||
        formatDate(new Date(), 'YYYY-MM-DD HH:mm:ss')
      this.signDate = outInDetails?.rentOrderVO?.signDate || ''
      // 验车视频
      const videoData = outInDetails.stockInfoVo.inspectionVideo
      if (videoData) {
        const videoList = typeof videoData === 'string' ? JSON.parse(videoData) : videoData
        if (Array.isArray(videoList)) {
          this.inspectionVideoPlus = videoList.map((item, i) => {
            if (typeof item === 'string') {
              return { url: item, name: this.extractFileName(item), uid: `video_${i}`, status: 'success' }
            }
            return { url: item.url || '', name: item.name || this.extractFileName(item.url || ''), uid: item.uid || `video_${i}`, status: 'success' }
          })
        }
      }
    },
    //  获取出入库id
    async getStockLogFindLastOne() {
      const { data, code } = await stockLogFindLastOne({
        orderId: Number(this.topPreviewModel.orderId),
        carId: this.topPreviewModel.carId,
        state: 0,
        type: 1, // 1 发车验车 2 退车验车
      })
      if (code === 1 && data) {
        const { id } = data
        // eslint-disable-next-line vue/no-mutating-props
        this.topPreviewModel.stockId = id
        return id
      }
    },
    // 取消
    cancel() {
      this.$confirm(
        '是否确认退出创建企业签约提车流程?退出后可在"企业租赁子订单列表-待履约-发车待验车"状态下找到订单并继续',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        },
      )
        .then(() => {
          this.$refreshBack() // 关闭当前tab
          this.$router.push({
            path: '/car_to_lease/forRentSignContract',
            query: {
              activeName: 'child',
            },
          })
        })
        .catch(() => null)
    },
    // 确认
    confirm() {
      this.$refs.stockRef.validate((valid) => {
        if (valid) {
          this.loading = true
          const data = this.parseSendData()
          editOutIn(data)
            .then(({ code }) => {
              this.loading = false
              if (code === 1) {
                this.$message.success('添加成功')
                this.$emit('confirm', this.active + 1)
              }
            })
            .catch(() => {
              this.loading = false
            })
        } else {
          this.$message.error('请填写必填项')
        }
      })
    },
    // 提交需要转换数据
    parseSendData() {
      const sendObj = { ...this.stock }
      sendObj.displayMile = Number(sendObj.displayMile)
      sendObj.takeOverManager = Number(sendObj.takeOverManager)
      sendObj.carId = this.topPreviewModel.carId
      sendObj.type = 1 // 1出库 2入库 3采购入库
      sendObj.id = Number(this.topPreviewModel.stockId)

      if (this.checkCarImgData.length) {
        let result = this.checkCarImgData?.map((item) => {
          const temp = { ...item }
          temp.urlList = item?.urlList.map((it) => it.url)
          return temp
        })
        result = result.filter((item) => item.urlList.length > 0).map((item) => item)
        sendObj.inspectionAttachment = JSON.stringify(result)
      } else {
        sendObj.inspectionAttachment = null
      }
      if (this.aboutCarImgsData.length) {
        let result = this.aboutCarImgsData?.map((item) => {
          const temp = { ...item }
          temp.urlList = item?.urlList.map((it) => it.url)
          return temp
        })
        result = result.filter((item) => item.urlList.length > 0).map((item) => item)
        sendObj.photo = JSON.stringify(result)
      } else {
        sendObj.photo = null
      }
      if (this.inspectionVideoPlus.length) {
        sendObj.inspectionVideo = this.inspectionVideoPlus.map((item) => item.url)
      } else {
        sendObj.inspectionVideo = []
      }
      return sendObj
    },
    init() {
      // 获取订单详情
      this.getLeaseContractOrderDetail()
      // 获取车管
      this.getCarTubeList()
    },
  },
  computed: {
    takeOverTimeOption() {
      /**
       * 出库-1：租赁设置中的签约时间-30天 <= 车辆交接时间 <= 当前时间
       * 入库-2：订单出库时间 <= 车辆交接时间 <= 当前时间
       * */
      const { signDate } = this
      return {
        disabledDate: (time) => {
          return (
            moment(time).isBefore(moment(signDate).subtract(30, 'days')) ||
            moment(time).isAfter(moment())
          )
        },
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.item,
.info,
.dialogwrap-add {
  ::v-deep .el-input--small {
    width: 205px;
  }
}
.float-right {
  float: right;
}
.sumbit-btns {
  text-align: center;
}
.fileUpload {
  display: flex;
  .txt {
    padding-right: 12px;
    width: 149px;
    box-sizing: border-box;
    text-align: right;
    color: #333;
  }
}
.photoUpload {
  margin-top: 15px;
  display: flex;
  .txt {
    padding-right: 12px;
    width: 149px;
    box-sizing: border-box;
    text-align: right;
  }
}
.uploadCommon_container {
  display: flex;
}
.imgList {
  padding-right: 12px;
  box-sizing: border-box;
  text-align: right;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  margin-bottom: 30px;
  .imgList_summay {
    display: flex;
    align-items: flex-start;
  }
}
.form-item-tips {
  font-size: 12px;
  color: #666;
  line-height: 20px;
}
.form-item-tips-red {
  font-size: 12px;
  color: red;
  line-height: 20px;
}
.lengthen {
  width: 230px;
}
.upload-box {
  padding-bottom: 10px;
  &__title {
    font-size: 14px;
    font-weight: 600;
    color: #1D2129;
    .sub-title-line {
      color: #4E5969;
      font-weight: 400;
    }
  }
  &__content {
    &__subtitle {
      font-size: 12px;
      font-weight: normal;
      line-height: 20px;
      color: #86909C;
    }
  }
}
</style>
